module.exports = __webpack_public_path__ + "static/scale-model-of-polar-express-in-akron-ohio-a24af57d0f133c217a42b9616cf33d13.png";